export function combineHandlers<T extends (event: any) => void>(
  ...handlers: (T | undefined)[]
) {
  return (event: Parameters<T>[0]) => {
    handlers.forEach(handler => {
      handler?.(event);
    });
  };
}
